export type Rule = {
  operationId: string;
};

export type CustomRule<T> = Rule & {
  [key: string]: T | string;
};

export enum AlertType {
  NEW_RELEVANT_FACTS = 'newRelevantFacts',
  NEW_CONVOCATION = 'newConvocation',
  NEW_DOCUMENT = 'newDocument',
  NEW_ARTICLE = 'newArticle',
}

export enum Status {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  PROCESSING = 'processing',
}

export type Alert = {
  id: number;
  type: AlertType;
  rule: Rule | CustomRule<string>;
  status: Status;
  computedOnce: boolean;
  sentAt: Date | null;
  deletedAt: Date | null;
  processedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
  sitemap_exclude: boolean;
};
